// ⚠ THE FIXED LABELS, SHARED. Mirrors REPOSITORY_LABELS in the api's adapter so the surface reads
// identically for every provider. They are constants rather than inline strings precisely so a
// future provider cannot quietly relabel one field and make the surface mean something different
// per tenant.
export const REPOSITORY_LABELS = {
  provider: 'Provider',
  repository: 'Repository',
  container: 'Library/Container',
  path: 'Path',
  open: 'Open Evidence Repository',
} as const;
